export default class Multilingual {
	initialize() {
		this.changereCaptchaLanguage();
	}

	changereCaptchaLanguage() {
        // Set the language of the captcha
        setTimeout(function() {

            var locale = $('html').attr('lang');
            setCaptchaLang(locale);
           
        }, 50);

        // Function to update the script called to get the captcha in the right language
        function setCaptchaLang(lang) {
            lang = lang || "en";

            var recaptchaContainer = document.querySelector(".captcha-container");
            if (!recaptchaContainer) { return; }

            // 1. Search for the ReCaptcha iframe
            const iframeGoogleCaptcha = recaptchaContainer.querySelector('iframe');

            // 2. Retrieve the current language
            const currentLang = iframeGoogleCaptcha.getAttribute("src").match(/hl=(.*?)&/).pop();

            // 3. Verify if the language that you want to set is different to the current one
            if (currentLang !== lang) {
                // 4. If it is, change it
                iframeGoogleCaptcha.setAttribute(
                    "src",
                    iframeGoogleCaptcha.getAttribute("src").replace(
                        /hl=(.*?)&/,
                        'hl=' + lang + '&'
                    )
                );
            }
        }
	}

} // end Multilingual